import React from "react";
import ReservationSegmentCancelWarning from "./ReservationSegmentCancelWarning";
import ReservationDetails from "../ReservationDetails/ReservationDetails";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalWarning from "../ModalWarning/ModalWarning";
import FixedFooter from "../admin/FixedFooter";
import DateHelper from "../DateHelper/DateHelper";
import numeral from "numeral";
import { parseISO } from "date-fns";

export default class ReservationSegmentCancel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
      notes: "",
      cancel_warning: false,
      displayWarningLabel: false,
      sendEmail: true,
      sendText: true,
      loading: false,
    };

    this.onChangeNotes = this.onChangeNotes.bind(this);
    this.onChangeCancelWarning = this.onChangeCancelWarning.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onChangeSendEmail = this.onChangeSendEmail.bind(this);
    this.onChangeSendText = this.onChangeSendText.bind(this);
  }

  /**
   * Render functions
   */

  render() {
    var self = this;

    //console.log("ReservationSegmentCancel", this.props);

    if (
      this.props.cancellation_rule &&
      this.props.cancellation_rule.custom_rule
    ) {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();
            self.setState({
              displayWarningModal: true,
            });
          },
        },
      ];
    } else {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: function (e) {
            self.onCancel();
            return false;
          },
        },
      ];
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-6">{this.renderRoomDetails()}</div>
          <div className="col-sm-6">{this.renderCancellationDetails()}</div>
        </div>
        {this.renderReservationDetails()}
   
        {/* {this.renderNotes()} */}
        {/* <div className="row">
          <div className="col-md-12">
            <div className="float-right form-group">
              <label>{I18n.t('send_email')} <span className="ss-help help" title={I18n.t('send_email_alert')}></span></label>
              <Switch 
                onText="yes" 
                offText="no" 
                onChange={this.onChangeSendEmail} 
                value={this.state.sendEmail} 
                switchId="send-email-switch"
              />            
            </div>
          </div>

        </div> */}
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <LoadingSpinner show={this.state.loading} />
        {this.state.displayWarningModal ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("cancel_room")}
                body={
                  <ReservationSegmentCancelWarning
                    {...self.state}
                    onChangeCancelWarning={self.onChangeCancelWarning}
                    custom_rule={self.props.cancellation_rule.custom_rule}
                  />
                }
                CancelSubmit
                onSubmit={this.onCancel}
                onCancel={() => this.setState({ displayWarningModal: false })}
                disabled_buttons={this.state.cancel_warning ? false : true}

              />,
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
        <FixedFooter {...this.props} {...this.state} label={I18n.t('room_balance_after_cancellation')} text={this.formatCurrency(this.props.balance)} showSendEmail={true} onChangeSendEmail={this.onChangeSendEmail} showSendText={this.props.enable_messaging} onChangeSendText={this.onChangeSendText}/>

      </div>
    );
  }

  renderReservationDetails() {
    return (
      <div className="row">
        <div className="col-md-12">
          <ReservationDetails {...this.props} />
        </div>
      </div>
    );
  }

  onChangeSendEmail(e) {
    this.setState({ sendEmail: e.target.checked });
  }

  onChangeSendText(e) {
    this.setState({ sendText: e.target.checked });
  }

  renderNotes() {
    return (
      <div className="row">
        <div className="col-sm-12" style={{ padding: "5px 22px" }}>
          <div className="form-group">
            <label>{I18n.t("notes")}</label>
            <textarea
              name="notes"
              rows="3"
              value={this.state.notes}
              className="form-control notes"
              onChange={this.onChangeNotes}
            ></textarea>
          </div>
        </div>
      </div>
    );
  }

  renderCancellationDetails() {
    if (this.props.cancellation_rule) {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{I18n.t("cancellation_details")}</h3>
          </div>
          <div className="panel-body">
            <div className="cancellation-rule">
              <div className="row" style={{ marginBottom: 10 }}>
                <div className="col-sm-12">
                  <div className="form-inline form-sentence text-center">
                    {I18n.t("reservations_cancelled")} &nbsp;
                    <span>
                      {this.props.cancellation_rule.time_value} {I18n.t("days")}
                    </span>
                    <span> &nbsp;</span>
                    {I18n.t(
                      "or_less_before_check_in_date_will_incur_the_following_cost"
                    )}
                    :
                  </div>
                </div>
              </div>

              <div className="row">
                {this.props.cancellation_rule &&
                this.props.cancellation_rule.percentage ? (
                  <div className="col-sm-12">
                    <div className="form-group text-center">
                      <label>
                        {I18n.t("percentage_of_lodging")}{" "}
                        <span
                          className="ss-help help"
                          title={I18n.t(
                            "percentage_of_lodging_helper_text"
                          )}
                        ></span>
                      </label>
                      <div>
                        {this.props.cancellation_rule.percentage
                          ? this.props.cancellation_rule.percentage * 100 + "%"
                          : ""}
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.props.cancellation_rule &&
                this.props.cancellation_rule.amount ? (
                  <div className="col-sm-12">
                    <div className="form-group text-center">
                      <label>
                        {I18n.t("fixed_amount")}{" "}
                        <span
                          className="ss-help help"
                          title={I18n.t(
                            "cancellation_rule_fixed_amount_helper_text"
                          )}
                        ></span>
                      </label>
                      <div>
                        {this.props.cancellation_rule.amount
                          ? "$" +
                            numeral(
                              this.props.cancellation_rule.amount / 100
                            ).format(this.state.numberFormat)
                          : ""}
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.props.cancellation_rule &&
                this.props.cancellation_rule.custom_rule ? (
                  <div className="col-sm-12">
                    <div className="form-group text-center">
                      <label>
                        {I18n.t("custom_cancellation_rule")}{" "}
                        <span
                          className="ss-help help"
                          title={I18n.t(
                            "cancellation_rule_custom_based_helper_text"
                          )}
                        ></span>
                      </label>
                      <div>{this.props.cancellation_rule.custom_rule}</div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {this.props.cancellation_rule &&
            !this.props.cancellation_rule.custom_rule ? (
              <div className="row">
                <div className="col-sm-12">
                  <label style={{ color: "red" }}>
                    {I18n.t("cancellation_fee_amount") +
                      ": " +
                      "$" +
                      numeral(this.props.cancellation_fee_amount / 100).format(
                        this.state.numberFormat
                      ) +
                      ` (${I18n.t("includes_taxes")})`}{" "}
                  </label>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      );
    } else {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{I18n.t("cancellation_details")}</h3>
          </div>
          <div className="panel-body">
            <div className="no-records">
              <span className="none">{I18n.t("none")}</span>
            </div>
          </div>
        </div>
      );
    }
  }

  renderRoomDetails() {
    var check_in_date = parseISO(this.props.reservation_segment.check_in_date);
    var check_out_date = parseISO(
      this.props.reservation_segment.check_out_date
    );
    var room = this.props.room
    if (this.props.room_group) {
      room = this.props.room_group.identifier
    }
    console.log("this.props.reservation_segment.check_in_date", this.props.reservation_segment.check_in_date);
    console.log("check_in_date", check_in_date);
    
    
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title">{I18n.t("room_details")}</h3>
        </div>
        <div className="panel-body">
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t("check_in_date")}</label>
              <div>
                {DateHelper.printDateToScreen(
                  check_in_date,
                  this.props.date_format
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t("check_out_date")}</label>
              <div>
                {DateHelper.printDateToScreen(
                  check_out_date,
                  this.props.date_format
                )}
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t("room_type")}</label>
              <div>{this.props.room_type}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t("room_identifier")}</label>
              <div>{room}</div>
            </div>
          </div>
          <br />
          <br />
          {this.props.reservation_segment.status != "held" ? (
            <div className="row">
              <div className="col-sm-6">
                <label>{I18n.t("rate")}</label>
                <div>{this.props.rate}</div>
              </div>
              <div className="col-sm-6">
                <label>{I18n.t("billing_policy")}</label>
                <div>
                  <a
                    href={`/admin/billing_policies/${
                      this.props.billing_policy
                        ? this.props.billing_policy.id
                        : null
                    }`}
                    className="modal-iframe"
                    data-fullscreen="true"
                  >
                    {this.props.billing_policy
                      ? this.props.billing_policy.name
                      : null}
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onCancel() {
    var self = this;

    this.setState({ loading: true });

    if (
      this.props.cancellation_rule &&
      this.props.cancellation_rule.custom_rule &&
      !this.state.cancel_warning
    ) {
      this.setState({ loading: false });
    } else {
      // console.log("this.props.new_folio_items", this.props.new_folio_items)
      let folio_items = this.props.new_folio_items.map((folioItem) =>
        JSON.stringify(folioItem)
      );
      // console.log("folio_items", folio_items);
      $.ajax({
        type: "POST",
        url: this.props.cancel_segment_path,
        data: {
          folio_items: folio_items,
          notes: this.state.notes,
          send_email: this.state.sendEmail,
          send_text: this.state.sendText,
        },
      }).done(function (data) {
        if (data.errors && data.errors.length) {
          self.setState({ loading: false });
        } else {
          self.setState({ loading: false });
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t("reservation_canceled_successfully"));
          }
          
          window.parent
            .$(window.parent)
            .trigger("reservationCanceledSuccessfully");

          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    }
  }

  //  onChangeSendEmail(e) {
  //   this.setState({ sendEmail: e.target.checked });
  // }

  onChangeNotes(noteText) {
    let notes = Object.assign({}, this.state.notes);
    notes = noteText;
    this.setState({
      notes: notes,
    });
  }

  onChangeCancelWarning(event) {
    this.setState({ cancel_warning: event.target.checked });
  }

  /**
   * Helper functions
   */

  formatCurrency(num) {
    return (
      I18n.t("number.currency.format.unit") +
      numeral(num / 100).format(
        "0" + I18n.t("number.currency.format.delimiter") + "0.00"
      )
    );
  }
}
